import { message } from 'antd';

// The axios instance interceptor rejects with a plain string (or an Error);
// NestJS validation 400s can carry message as a string[] — surface all of it.
export const showRestError = (err: unknown) => {
  let text = 'Something went wrong';

  if (typeof err === 'string') {
    text = err;
  } else if (Array.isArray(err)) {
    text = err.join('; ');
  } else if (err && typeof err === 'object') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const msg = (err as any).message;
    text = Array.isArray(msg) ? msg.join('; ') : msg || text;
  }

  message.error(text);
};
